import { BasicNemesisCard } from '../../../../aer-types/types'

export const basicNemesisCards: BasicNemesisCard[] = [
  {
    id: 'DrillbeakWurm-NA',
    expansion: 'NA',
    tier: 1,
    type: 'Minion',
    name: 'Robal Drążodzioby',
    hp: 6,
    effect: `
      <p>
        <b>Trwały:</b> Dowolny gracz otrzymuje 1 obrażenie. Gravehold otrzymuje 1 obrażenie.
      </p>
    `,
  },
  {
    id: 'CarriodeColony-NA',
    expansion: 'NA',
    tier: 1,
    type: 'Minion',
    name: 'Kolonia Padlinodów',
    hp: 4,
    effect: `
      <p>
        <b>Natychmiast:</b> Ten Poplecznik otrzymuje obrażenia równe liczbie graczy w grze.<br />
        <b>Trwały:</b> Wyzwolenie.
      </p>
    `,
  },
  {
    id: 'ChaosOrb-NA',
    expansion: 'NA',
    tier: 1,
    type: 'Power',
    name: 'Sfera Chaosu',
    power: 3,
    effect: `
      <p>
        <b>Aby odrzucić:</b> Odrzuć 6 <span class="aether">&AElig;</span>.<br />
        <br />
        <b>Moc 3:</b> Wyzwolenie, Gravehold otrzymuje 4 obrażenia.
      </p>
    `,
  },
  {
    id: 'Disorient-NA',
    expansion: 'NA',
    tier: 1,
    type: 'Attack',
    name: 'Dezorientacja',
    effect: `
      <p>
        Wyzwolenie. Dowolny gracz otrzymuje 1 obrażenie i odrzuca kartę z ręki. Jeśli jest nią Klejnot, Gravehold otrzymuje 2 obrażenia.
      </p>
    `,
  },
  {
    id: 'Rend-NA',
    expansion: 'NA',
    tier: 1,
    type: 'Attack',
    name: 'Rozerwanie',
    effect: `
      <p>
        Wyzwolenie. Gravehold otrzymuje 1 obrażenie. Dowolny gracz otrzymuje 2 obrażenia.
      </p>
    `,
  },
  {
    id: 'UnnervingHowl-NA',
    expansion: 'NA',
    tier: 1,
    type: 'Power',
    name: 'Przerażający Skowyt',
    power: 2,
    effect: `
      <p>
        <b>Moc 2:</b> Wyzwolenie. Dowolny gracz odrzuca dwa Klejnoty z ręki.
      </p>
    `,
  },
  {
    id: 'CeaselessDarkness-NA',
    expansion: 'NA',
    tier: 1,
    type: 'Power',
    name: 'Ceaseless Darkness',
    power: 2,
    effect: `
      <p>
        <b>Aby odrzucić:</b> Wydaj 5 <span class="aether">&AElig;</span>.<br />
        <br />
        <b>Moc 2:</b> Wyzwolenie. Dowolny gracz otrzymuje 3 obrażenia. Dowolny gracz odrzuca kartę z ręki.
      </p>
    `,
  },
  {
    id: 'AetherShock-NA',
    expansion: 'NA',
    tier: 1,
    type: 'Attack',
    name: 'Eteryczne Porażenie',
    effect: `
      <p>
        Wyzwolenie. Gracz z największą liczbą przygotowanych Zaklęć otrzymuje 1 obrażenie i odrzuca jedno przygotowane Zaklęcie.
      </p>
    `,
  },
  {
    id: 'Decimate-NA',
    expansion: 'NA',
    tier: 1,
    type: 'Attack',
    name: 'Zdziesiątkowanie-NP',
    effect: `
      <p>
        Dwukrotne Wyzwolenie. Dowolny z graczy otrzymuje 2 Ładunki.
        <span class="or">ALBO</span>
        Gravehold otrzymuje 4 obrażenia.
      </p>
    `,
  },
  {
    id: 'BlindEnigma-NA',
    expansion: 'NA',
    tier: 1,
    type: 'Minion',
    name: 'Petroglif Pułapka-NP',
    hp: 7,
    effect: `
      <p>
        <b>Trwały:</b> Dowolny gracz otrzymuje 1 obrażenie. Jeżeli ostatnia dobrana karta Nemezis była drugiego rzędu lub wyższego,
        ten gracz otrzymuje 2 dodatkowe obrażenia.
      </p>
    `,
  },
  {
    id: 'PlanarCollision-NA',
    expansion: 'NA',
    tier: 1,
    type: 'Power',
    name: 'Kolizja Planetarna-NP',
    power: 2,
    effect: `
      <p>
        <b>Aby odrzucić:</b> Odrzuć dwa przygotowane Zaklęcia.<br />
        <br />
        <b>Moc 2:</b> Dwukrotne Wyzwolenie.
      </p>
    `,
  },
  {
    id: 'SpiritSnare-NA',
    expansion: 'NA',
    tier: 1,
    type: 'Power',
    name: 'Duchowa Matnia',
    power: 3,
    effect: `
      <p>
        <b>Aby odrzucić:</b> Odrzuć z ręki kartę o koszcie co najmniej 5 <span class="aether">&AElig;</span>.<br />
        <br />
        <b>Moc 3:</b> Wyzwolenie. Dowolny gracz odrzuca Zaklęcie z ręki oraz otrzymuje 2 obrażenia.
      </p>
    `,
  },
  {
    id: 'Dement-NA',
    expansion: 'NA',
    tier: 2,
    type: 'Attack',
    name: 'Otępienie',
    effect: `
      <p>
        Dwukrotne Wyzwolenie. Dowolny gracz otrzymuje 1 obrażenie i umieszcza najdroższą kartę z ręki na wierzchu swojej talii.
      </p>
    `,
  },
  {
    id: 'Decay-NA',
    expansion: 'NA',
    tier: 2,
    type: 'Attack',
    name: 'Rozkład-NP',
    effect: `
      <p>
        Dwukrotne Wyzwolenie. Dowolny gracz albo Gravehold otrzymuje 3 obrażenia.
      </p>
    `,
  },
  {
    id: 'CullingScythe-NA',
    expansion: 'NA',
    tier: 2,
    type: 'Power',
    name: 'Żniwo',
    power: 2,
    effect: `
      <p>
        <b>Aby odrzucić:</b> Wydaj 7 <span class="aether">&AElig;</span>.<br />
        <br />
        <b>Moc 2:</b> Wyzwolenie. Gracz z najmniejszą liczbą punktów życia otrzymuje 4 obrażenia.
      </p>
    `,
  },
  {
    id: 'Fugue-NA',
    expansion: 'NA',
    tier: 2,
    type: 'Attack',
    name: 'Haniebna Ucieczka',
    effect: `
      <p>
        Dowolny gracz odrzuca trzy karty z ręki oraz otrzymuje 2 obrażenia.
      </p>
    `,
  },
  {
    id: 'VolcanicZala-NA',
    expansion: 'NA',
    tier: 2,
    type: 'Minion',
    name: 'Wulkaniczna Zala',
    hp: 10,
    effect: `
      <p>
        <b>Trwały:</b> Gravehold otrzymuje 3 obrażenia.
        <span class="or">ALBO</span>
        Dowolny gracz traci 2 Ładunki.
      </p>
    `,
  },
  {
    id: 'PortalGuardian-NA',
    expansion: 'NA',
    tier: 2,
    type: 'Minion',
    name: 'Stróż Portalu',
    hp: 8,
    effect: `
      <p>
        <b>Trwały:</b> Wyzwolenie. Dowolny gracz otrzymuje 1 obrażenie.
      </p>
    `,
  },
  {
    id: 'ObliteratingMeteor-NA',
    expansion: 'NA',
    tier: 2,
    type: 'Power',
    name: 'Miażdżący Meteoryt',
    power: 1,
    effect: `
      <p>
        <b>Aby odrzucić:</b> Odrzuć cztery karty z ręki.<br />
        <br />
        <b>Moc 1:</b> Dwukrotne Wyzwolenie. Gravehold otrzymuje 3 obrażenia.
      </p>
    `,
  },
  {
    id: 'Mutilate-NA',
    expansion: 'NA',
    tier: 2,
    type: 'Attack',
    name: 'Okaleczenie',
    effect: `
      <p>
        Wyzwolenie. Gracze wspólnie odrzucają dwa przygotowane Zaklęcia. Dowolny gracz otrzymuje 2 obrażenia.
      </p>
    `,
  },
  {
    id: 'Needlemaw-NA',
    expansion: 'NA',
    tier: 2,
    type: 'Minion',
    name: 'Szpilopaszcze-NP',
    hp: 11,
    effect: `
      <p>
        <b>Trwały:</b> Gravehold otrzymuje 2 obrażenia.
      </p>
    `,
  },
  {
    id: 'MorbidGyre-NA',
    expansion: 'NA',
    tier: 2,
    type: 'Power',
    name: 'Makabryczny Wir-NP',
    power: 1,
    effect: `
      <p>
        <b>Aby odrzucić:</b> Wydaj 7 <span class="aether">&AElig;</span>.<br />
        <br />
        <b>Moc 1:</b> Dwukrotne Wyzwolenie. Gracze wspólnie odrzucają trzy karty z ręki.
      </p>
    `,
  },
  {
    id: 'GravitySplinter-NA',
    expansion: 'NA',
    tier: 2,
    type: 'Power',
    name: 'Rozszczepienie Grawitacji-NP',
    power: 2,
    effect: `
      <p>
        <b>Aby odrzucić:</b> Wydaj 7 <span class="aether">&AElig;</span>.<br />
        <br />
        <b>Moc 2:</b> Dwukrotne Wyzwolenie. Gracz z najmniejszą liczbą otwartych Bram otrzymuje 3 obrażenia.
      </p>
    `,
  },
  {
    id: 'Eliminate-NA',
    expansion: 'NA',
    tier: 3,
    type: 'Attack',
    name: 'Wyeliminowanie',
    effect: `
      <p>
        Trzykrotne Wyzwolenie.
        <span class="or">ALBO</span>
        Gravehold otrzymuje 6 obrażenie.
        <span class="or">ALBO</span>
        Dowolny gracz otrzymuje 5 obrażeń.
      </p>
    `,
  },
  {
    id: 'CrushingStorm-NA',
    expansion: 'NA',
    tier: 3,
    type: 'Power',
    name: 'Huragan Zniszczenia',
    power: 1,
    effect: `
      <p>
        <b>Aby odrzucić:</b> Zniszcz dwie Otwarte Bramy.<br />
        <br />
        <b>Moc 1:</b> Trzykrotne Wyzwolenie.
      </p>
    `,
  },
  {
    id: 'GnashingMaw-NA',
    expansion: 'NA',
    tier: 3,
    type: 'Power',
    name: 'Zgrzytające Żuwaczki',
    power: 2,
    effect: `
      <p>
        <b>Moc 2:</b> Wyzwolenie. Gracz z najdroższym przygotowanym Zaklęciem niszczy je.
        Jeśli było to Zaklęcie o wartości nie większej niż 4 <span class="aether">&AElig;</span>, 
        następuje Wyzwolenie i dowolny gracz otrzymuje 3 obrażenia.
      </p>
    `,
  },
  {
    id: 'Disperse-NA',
    expansion: 'NA',
    tier: 3,
    type: 'Attack',
    name: 'Rozbicie',
    effect: `
      <p>
        Dwukrotne Wyzwolenie. Dowolny gracz otrzymuje 2 obrażenia i niszczy najdroższą kartę z ręki.
      </p>
    `,
  },
  {
    id: 'Gore-NA',
    expansion: 'NA',
    tier: 3,
    type: 'Attack',
    name: 'Jatka',
    effect: `
      <p>
        Dwukrotne Wyzwolenie. Gracz z najdroższą kartą na ręce odrzuca trzy karty z ręki.
        Następnie za każdą kartę na ręce tego gracza, która kosztuje conajmniej 2 <span class="aether">&AElig;</span>,
        ten gracz otrzymuje 2 obrażenia.
      </p>
    `,
  },
  {
    id: 'HexofDestruction-NA',
    expansion: 'NA',
    tier: 3,
    type: 'Power',
    name: 'Hex of Destruction',
    power: 2,
    effect: `
      <p>
        <b>Aby odrzucić:</b> Wydaj 8 <span class="aether">&AElig;</span>.<br />
        <br />
        <b>Moc 2:</b> Dwukrotne Wyzwolenie. Gravehold otrzymuje 4 obrażenia. Dowolny gracz niszczy cztery wierzchnie karty ze swojej talii.
      </p>
    `,
  },
  {
    id: 'EternalWatcher-NA',
    expansion: 'NA',
    tier: 3,
    type: 'Minion',
    name: 'Wieczny Wartownik',
    hp: 10,
    effect: `
      <p>
        <b>Trwały:</b> Dowolny gracz otrzymuje 3 obrażenia. Jeśli ten Poplecznik ma 6 punktów życia lub mniej, otrzymuje 3 punkty życia.
      </p>
    `,
  },
  {
    id: 'Sunder-NA',
    expansion: 'NA',
    tier: 3,
    type: 'Attack',
    name: 'Wrogi Napór',
    effect: `
      <p>
        Gravehold otrzymuje 4 obrażenia oraz gracz z najmniejszą liczbą punktów życia otrzymuje 4 obrażenia.
        <span class="or">ALBO</span>
        Wtasuj wszystkie karty tury Nemezis do talii tur.
      </p>
    `,
  },
  {
    id: 'Topple-NA',
    expansion: 'NA',
    tier: 3,
    type: 'Attack',
    name: 'Powalenie',
    effect: `
      <p>
        Dwukrotne Wyzwolenie. Gravehold otrzymuje 4 obrażenia.
      </p>
    `,
  },
  {
    id: 'MonstrosityofOmens-NA',
    expansion: 'NA',
    tier: 3,
    type: 'Minion',
    name: 'Abominacja Omenów-NP',
    shields: 5,
    hp: 0,
    effect: `
      <p>
        Wartość obrażeń zadawanych temu Poplecznikowi jest obniżana do 1 obrażenia.<br />
        <br />
        <b>Trwały:</b> Gravehold otrzymuje obrażenia w liczbie równej aktualnej liczbie punktów życia tego Poplecznika.
      </p>
    `,
  },
  {
    id: 'DoomAegis-NA',
    expansion: 'NA',
    tier: 3,
    type: 'Power',
    name: 'Tarcza Zguby',
    power: 1,
    effect: `
      <p>
        <b>Aby odrzucić:</b> Wydaj 7 <span class="aether">&AElig;</span>.<br />
        <br />
        <b>Moc 1:</b> Wyzwolenie. Gracz z największą liczbą Ładunków otrzymuje 4 obrażenia i odrzuca wszystkie Ładunki.
      </p>
    `,
  },
]
